import React, { useState } from "react";
import "./Navbar.css";

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const handleMenuItemClick = () => {
        setIsOpen(false); // Close the menu when an item is clicked
    };

    return (
        <nav className="navbar">
            <div className="navbar-left">
                Tim & Seneca
            </div>
            <div className="hamburger" onClick={toggleMenu}>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <ul className={`navbar-menu ${isOpen ? "active" : ""}`}>
                <li>
                    <a href="#welcome" onClick={handleMenuItemClick}>Welcome</a>
                </li>
                <li>
                    <a href="#venue" onClick={handleMenuItemClick}>Venue</a>
                </li>
                <li>
                    <a href="#events" onClick={handleMenuItemClick}>Events</a>
                </li>
                <li>
                    <a href="#our-story" onClick={handleMenuItemClick}>Our Story</a>
                </li>
                <li>
                    <a href="#information" onClick={handleMenuItemClick}>Information</a>
                </li>
                <li>
                    <a href="#activities" onClick={handleMenuItemClick}>Things to Do</a>
                </li>
                <li>
                    <a href="#wedding-party" onClick={handleMenuItemClick}>Wedding Party</a>
                </li>
                <li>
                    <a href="#rsvp" onClick={handleMenuItemClick}>RSVP</a>
                </li>
                <li>
                    <a href="#registry" onClick={handleMenuItemClick}>Registry</a>
                </li>
            </ul>
        </nav>
    );
};

export default Navbar;
